export enum AssetOfflineRetention {
    API = 'Through a Custom API',
    File = 'As an (Encrypted) File',
}
